import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const showAddUserKeyModal = () => ({type: Modal.toggleModalConstant(Constants.ADD_USER_KEY)})

export type FetchUserSettings = Request.Request
export const fetchUserSettings: FetchUserSettings = (selectedCommunity: string, usernname: string) =>
  Request.requestActionCreator(Constants.FETCH_USER_SETTINGS)({
    method: 'GET',
    url: `${Constants.SERVER_RESOURCE}/${selectedCommunity}`,
  })

export const createUserKey: Modal.Submit<Types.UserKeyModalData> =
  (selectedCommunity: string, payload: Types.UserKeyModalData) =>
    Request.requestActionCreator(Constants.ADD_USER_KEY)({
      method: 'POST',
      payload,
      url: `${Constants.SERVER_RESOURCE}/${selectedCommunity}/keys`,
    })

export const refreshUserKey: Request.Request = (selectedCommunity: string, key: string) =>
  Request.requestActionCreator(Constants.REFRESH_USER_KEY)({
    method: 'PUT',
    url: `${Constants.SERVER_RESOURCE}/${selectedCommunity}/keys/${key}`,
  })

export const updateAddUserKeyModalField = (field: Modal.ModalField) =>
  ({type: Modal.updateModalConstant(Constants.ADD_USER_KEY), field})

export const confirmAction = () => confirm('Are you sure?')



// WEBPACK FOOTER //
// ./src/pages/user-settings/actions.ts